/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Platform API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ContextListResponse
} from '../../../types/platform/contextListResponse';

import type {
  EntityDetailResponse
} from '../../../types/platform/entityDetailResponse';

import type {
  EntityListResponse
} from '../../../types/platform/entityListResponse';

import type {
  GetEntityPathParameters
} from '../../../types/platform/getEntityPathParameters';

import type {
  HumaAPIError
} from '../../../types/platform/humaAPIError';

import type {
  ListEntitiesParams
} from '../../../types/platform/listEntitiesParams';

import { customFetch } from '../../../../src/custom-fetch';
import type { ErrorType } from '../../../../src/custom-fetch';

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getContextsResponse200 = {
  data: ContextListResponse
  status: 200
}

export type getContextsResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getContextsResponseSuccess = (getContextsResponse200) & {
  headers: Headers;
};
export type getContextsResponseError = (getContextsResponseDefault) & {
  headers: Headers;
};

export type getContextsResponse = getContextsResponseSuccess

export const getGetContextsUrl = () => {




  return `/auth/v1/sorm/schema/contexts`
}

/**
 * @summary Get context definitions
 */
export const getContexts = async ( options?: Parameters<typeof customFetch>[1]): Promise<getContextsResponse> => {

  return customFetch<getContextsResponse>(getGetContextsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetContextsQueryKey = () => {
    return [
    `/auth/v1/sorm/schema/contexts`
    ] as const;
    }


export const getGetContextsQueryOptions = <TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContextsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContexts>>> = ({ signal }) => getContexts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContextsQueryResult = NonNullable<Awaited<ReturnType<typeof getContexts>>>
export type GetContextsQueryError = ErrorType<HumaAPIError>


export function useGetContexts<TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContexts>>,
          TError,
          Awaited<ReturnType<typeof getContexts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContexts<TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContexts>>,
          TError,
          Awaited<ReturnType<typeof getContexts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContexts<TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get context definitions
 */

export function useGetContexts<TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContextsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetContextsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContextsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContexts>>> = ({ signal }) => getContexts({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetContextsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getContexts>>>
export type GetContextsSuspenseQueryError = ErrorType<HumaAPIError>


export function useGetContextsSuspense<TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContextsSuspense<TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetContextsSuspense<TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get context definitions
 */

export function useGetContextsSuspense<TData = Awaited<ReturnType<typeof getContexts>>, TError = ErrorType<HumaAPIError>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getContexts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetContextsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listEntitiesResponse200 = {
  data: EntityListResponse
  status: 200
}

export type listEntitiesResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type listEntitiesResponseSuccess = (listEntitiesResponse200) & {
  headers: Headers;
};
export type listEntitiesResponseError = (listEntitiesResponseDefault) & {
  headers: Headers;
};

export type listEntitiesResponse = listEntitiesResponseSuccess

export const getListEntitiesUrl = (params?: ListEntitiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/auth/v1/sorm/schema/entities?${stringifiedParams}` : `/auth/v1/sorm/schema/entities`
}

/**
 * @summary List available entities
 */
export const listEntities = async (params?: ListEntitiesParams, options?: Parameters<typeof customFetch>[1]): Promise<listEntitiesResponse> => {

  return customFetch<listEntitiesResponse>(getListEntitiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEntitiesQueryKey = (params?: ListEntitiesParams,) => {
    return [
    `/auth/v1/sorm/schema/entities`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEntitiesQueryOptions = <TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(params?: ListEntitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEntitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEntities>>> = ({ signal }) => listEntities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEntitiesQueryResult = NonNullable<Awaited<ReturnType<typeof listEntities>>>
export type ListEntitiesQueryError = ErrorType<HumaAPIError>


export function useListEntities<TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListEntitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEntities>>,
          TError,
          Awaited<ReturnType<typeof listEntities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEntities<TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(
 params?: ListEntitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listEntities>>,
          TError,
          Awaited<ReturnType<typeof listEntities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEntities<TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(
 params?: ListEntitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List available entities
 */

export function useListEntities<TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(
 params?: ListEntitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEntitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListEntitiesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(params?: ListEntitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEntitiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEntities>>> = ({ signal }) => listEntities(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListEntitiesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listEntities>>>
export type ListEntitiesSuspenseQueryError = ErrorType<HumaAPIError>


export function useListEntitiesSuspense<TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(
 params: undefined |  ListEntitiesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEntitiesSuspense<TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(
 params?: ListEntitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListEntitiesSuspense<TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(
 params?: ListEntitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List available entities
 */

export function useListEntitiesSuspense<TData = Awaited<ReturnType<typeof listEntities>>, TError = ErrorType<HumaAPIError>>(
 params?: ListEntitiesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listEntities>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEntitiesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getEntityResponse200 = {
  data: EntityDetailResponse
  status: 200
}

export type getEntityResponseDefault = {
  data: HumaAPIError
  status: Exclude<HTTPStatusCodes, 200>
}

export type getEntityResponseSuccess = (getEntityResponse200) & {
  headers: Headers;
};
export type getEntityResponseError = (getEntityResponseDefault) & {
  headers: Headers;
};

export type getEntityResponse = getEntityResponseSuccess

export const getGetEntityUrl = ({ entityName }: GetEntityPathParameters,) => {




  return `/auth/v1/sorm/schema/entities/${entityName}`
}

/**
 * @summary Get entity details
 */
export const getEntity = async ({ entityName }: GetEntityPathParameters, options?: Parameters<typeof customFetch>[1]): Promise<getEntityResponse> => {

  return customFetch<getEntityResponse>(getGetEntityUrl({ entityName }),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEntityQueryKey = ({ entityName }: GetEntityPathParameters,) => {
    return [
    `/auth/v1/sorm/schema/entities/${entityName}`
    ] as const;
    }


export const getGetEntityQueryOptions = <TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>({ entityName }: GetEntityPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntityQueryKey({ entityName });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntity>>> = ({ signal }) => getEntity({ entityName }, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: entityName !== null && entityName !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntityQueryResult = NonNullable<Awaited<ReturnType<typeof getEntity>>>
export type GetEntityQueryError = ErrorType<HumaAPIError>


export function useGetEntity<TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEntityPathParameters, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntity>>,
          TError,
          Awaited<ReturnType<typeof getEntity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntity<TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEntityPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEntity>>,
          TError,
          Awaited<ReturnType<typeof getEntity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntity<TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEntityPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get entity details
 */

export function useGetEntity<TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>(
 { entityName }: GetEntityPathParameters, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntityQueryOptions({ entityName },options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetEntitySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>({ entityName }: GetEntityPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEntityQueryKey({ entityName });



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntity>>> = ({ signal }) => getEntity({ entityName }, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEntitySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEntity>>>
export type GetEntitySuspenseQueryError = ErrorType<HumaAPIError>


export function useGetEntitySuspense<TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEntityPathParameters, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitySuspense<TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEntityPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEntitySuspense<TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>(
 pathParams: GetEntityPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get entity details
 */

export function useGetEntitySuspense<TData = Awaited<ReturnType<typeof getEntity>>, TError = ErrorType<HumaAPIError>>(
 { entityName }: GetEntityPathParameters, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntity>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEntitySuspenseQueryOptions({ entityName },options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






